
interface NavigationItem {
  label: string;
  href: string;
  isActive?: boolean;
}

interface SidebarNavigationProps {
  className?: string;
}

export function SidebarNavigation({ className = '' }: SidebarNavigationProps) {
  const navigationItems: NavigationItem[] = [
    { label: 'Home', href: '/', isActive: true },
    { label: 'Airpark Calendar', href: '/airparkcalendar.htm' },
    { label: 'Airpark Information', href: '/airparkinformation.htm' },
    { label: 'Pilot Information', href: '/pilotinformation.htm' },
    { label: 'Driving Directions', href: '/drivingdirections.htm' },
    { label: 'Member Area', href: '/members/memberarea.htm' },
    { label: 'Real Estate', href: '/realestate.htm' },
    { label: 'Newsletters', href: '/newsletters.htm' },
    { label: 'Pictures', href: '/pictures.htm' },
    { label: 'Aviation Related Links', href: '/links.htm' },
    { label: 'The Community Building', href: '/newshack.htm' },
  ];

  return (
    <div className={`w-48 bg-white ${className}`}>
      <nav className="space-y-1">
        {navigationItems.map((item) => (
          <div key={item.href} className="relative">
            {item.isActive ? (
              <div className="px-4 py-2 text-blue-800 font-normal bg-white">
                {item.label}
              </div>
            ) : (
              <a
                href={item.href}
                className="block px-4 py-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 transition-colors font-normal"
              >
                {item.label}
              </a>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}